<template>
  <div class="order_confirm" v-if="checkout">
    <van-nav-bar
      title="确认订单"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="card" style="padding-bottom: 20px;" v-if="checkout.need_address">
      <div style="height: 20px;"></div>
      <div class="sm" style="margin-bottom: 15px;">收货地址</div>
      <div class="app-cell" @click="onSelect">
        <div class="app-navigator navi" v-if="checkout.address">
          <div style="width: 350px;">
            <div class="app-dis-vcenter-row h">
              <div>{{ checkout.address.name }}</div>
              <div style="margin-left: 15px;">{{ checkout.address.tel }}</div>
            </div>
            <div class="md" style="max-width: 298px;">
              {{ checkout.address.province }}{{ checkout.address.city }}{{ checkout.address.county }}{{ checkout.address.detail }}
            </div>
          </div>
          <img
            src="https://nginx-front.oss-cn-shanghai.aliyuncs.com/running-sys/right-arrow.png"
            class="app-navigator-next"
          >
        </div>
        <div v-else class="confirm-order-add-address">
          <img src="http://nginx-front.oss-cn-shanghai.aliyuncs.com/running-sys/add_address.png" alt="" style="width:130px;"></div>
        </div>
    </div>

    <div class="card" style="margin-bottom: 0;">
      <div style="height: 10px;"></div>
      <div class="header">赛事信息</div>
      <div class="body">
        <div class="title">
          <div>{{ checkout.race.name }}</div>
          <div v-if="!checkout.is_has_gift">¥ {{ checkout.race.price }}</div>
        </div>
        <div class="info">
          赛事时间：{{ checkout.race.start_time }} ~ {{ checkout.race.end_time }}
        </div>
        <div class="info">赛事距离：{{ checkout.race.distance }}公里</div>
      </div>
    </div>

    <div v-if="checkout.is_has_gift" class="card gift-card">
      <div style="height: 10px;"></div>
      <div class="Collocation">
        <div class="card-tit isShowTit"><span>请选择套餐</span></div>

        <van-radio-group v-model="selectedGiftId">
          <van-cell-group>
            <van-cell
              v-for="(gift, index) in checkout.gifts"
              :key="index"
              :class="{'active-gift': selectedGiftId === gift.uuid}"
              class="gift-block"
              title-class="cell-title"
              clickable
              @click="onGiftChoose(gift.uuid)"
            >
              <template slot="title">
                <div class="gift-title">{{gift.title}}</div>
              </template>
              <template slot="label">
                <div class="gift-content">{{gift.content}}</div>
                <div class="gift-price">¥{{gift.price_display }}</div>
              </template>
              <van-radio :name="gift.uuid" checked-color="#F54966"/>
            </van-cell>
          </van-cell-group>
        </van-radio-group>

      </div>
    </div>

    <div class="card">
      <div style="height: 10px;"></div>
      <div class="header">付款信息</div>
      <div class="body">
        <div class="title">
          <div>商品总额</div>
          <div>¥ {{ orderPrice }}</div>
        </div>
      </div>
      <!-- <div class="body" style="margin-top:20px">
        <div class="title">
          <div>优惠金额</div>
          <div style="color: #ff7135;">¥ {{ discountPrice }}</div>
        </div>
      </div> -->
    </div>

    <bottom-pay-btn class="bgwhite" :price="realPrice" :fixed="true" @confirm="gotoPay" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CellGroup, Cell, Toast, NavBar, Field, Icon, Button, CheckboxGroup, Checkbox, Panel, RadioGroup, Radio, Dialog } from 'vant'
import BottomPayBtn from '@/components/BottomPayBtn'
import { enrollRace } from '@/api/race'
import { raceOrderCreateCheckout, orderPay } from '@/api/order'
import { isWeixin, wrapToBr } from '@/utils/index'
import { callPay } from '@/utils/wx'

export default {
  name: 'RaceOrderConfirm',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Panel.name]: Panel,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    BottomPayBtn
  },
  data () {
    return {
      raceId: null,
      ruleId: null,
      profileId: null,
      selectedGiftId: null,
      needGifts: [],
      checkout: null
    }
  },
  computed: {
    ...mapGetters([
      'checkoutAddress'
    ]),
    selectedGift () {
      if (!(this.checkout && this.checkout.is_has_gift && this.selectedGiftId)) return null

      for (let index = 0; index < this.checkout.gifts.length; index++) {
        const gift = this.checkout.gifts[index]
        if (gift.uuid === this.selectedGiftId) {
          return gift
        }
      }
      return null
    },
    orderPrice () {
      let price = this.checkout.price
      const selectedGift = this.selectedGift
      if (this.checkout.is_has_gift && selectedGift) {
        price += parseFloat(selectedGift.price)
      }

      return price.toFixed(2)
    },
    discountPrice () {
      let price = parseFloat(this.orderPrice) - parseFloat(this.realPrice)
      price = price < 0 ? 0 : price
      return price.toFixed(2)
    },
    realPrice () {
      let price = this.checkout.price
      const selectedGift = this.selectedGift
      if (this.checkout.is_has_gift && selectedGift) {
        price += parseFloat(selectedGift.price)
      }
      price = price < 0 ? 0 : price

      return price.toFixed(2)
    }
  },
  created () {
    let raceId = this.$route.params.race_id || ''
    this.ruleId = this.$route.query.rule || ''
    this.profileId = this.$route.query.profile || ''
    if (!this.profileId || !this.ruleId) {
      Toast('页面错误')
      return
    }

    this.createCheckout(raceId, {
      rule_id: this.ruleId,
      profile_id: this.profileId,
      address_id: this.checkoutAddress
    })
  },
  methods: {
    async createCheckout (raceId, data) {
      let response = await raceOrderCreateCheckout(raceId, data)
      this.checkout = response.data
      this.checkout.gifts.map((gift) => {
        gift.price_display = (parseFloat(gift.price) + parseFloat(this.checkout.race.price)).toFixed(2)
        gift.content = wrapToBr(gift.content)
      })
      // if (this.checkout.gifts.length) {
      //   this.selectedGiftId = this.checkout.gifts[0].uuid
      // }
      this.$store.dispatch('setCheckoutAddress', this.checkout.address.uuid)
    },
    onSelect () {
      this.$router.push('/my/address?from=checkout&address_id=' + this.checkoutAddress + '&path=' + encodeURIComponent(this.$route.fullPath))
    },
    gotoPay () {
      if (this.checkout.gifts.length && !this.selectedGiftId) {
      //   Dialog.confirm({
      //     title: '确定支付',
      //     message: '该课程包含礼包，选择礼包更优惠哦！',
      //     confirmButtonText: '我再看看',
      //     cancelButtonText: '确认支付',
      //   }).then(() => {
      //     // on confirm
      //   }).catch(() => {
      //     this.onPay()
      //   });
      // } else {
      //   this.onPay()
        Toast('请选择套餐')
        return
      }
      this.onPay()
    },
    async onPay () {
      let response = null
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      response = await enrollRace(this.checkout.race.id, {
        rule_id: this.ruleId,
        profile_id: this.profileId,
        address_id: this.checkoutAddress,
        gift_id: this.selectedGiftId
      })
      Toast.clear()
      if (response.data.is_free) {
        this.$router.push('/my/race')
        return
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      response = await orderPay(response.data.order_id)
      Toast.clear()

      if (isWeixin()) {
        callPay(response.data)
      } else {
        Toast('请使用微信浏览器')
      }
    },
    onGiftChoose (checked) {
      if (this.selectedGiftId && this.selectedGiftId === checked) {
        // this.selectedGiftId = null
      } else {
        this.selectedGiftId = checked
      }
    },
    onGiftShow () {
      Toast('支付完成后在订单详情处填写礼包具体信息')
    },
    onVerify () {
    },
    onToggle () {
      this.$refs.checkbox.toggle()
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.order_confirm {
  background-color: #f8f8f8;
  .sm {
    font-size: 30px;
    color: #c5c8cc;
    line-height: 1;
    font-weight: 700;
  }
  .h {
    font-size: 32px;
    color: #1d252c;
    line-height: 1;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 48px;
  }
  .md {
      font-size: 26px;
      color: #949494;
      line-height: 1;
  }
  .app-dis-vcenter-row {
    display: flex;
    align-items: center;
  }
  .app-navigator {
    display: flex;
    align-items: center;
  }
  .app-navigator-next{
      margin-left: 10px;
      width: 14px;
      height: 20px;
  }
  .card {
    background-color: #fff;
    padding: 0 25px 20px;
    margin-bottom: 20px;
    .header {
      font-size: 28px;
      color: #c5c8cc;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .body {
      .title {
        display: flex;
        justify-content: space-between;
        font-size: 32px;
        color: #1D252C;
        line-height: 1;
        font-weight: bold;
        margin-bottom: 25px;
        // line-height: 0.48rem;
      }
      .info {
        font-size: 28px;
        color: #949494;
        line-height: 1.4;
        // margin-bottom: 15px;
      }
    }
  }
  .Collocation {
    overflow-y: hidden;
    // border: 2px solid #ebebeb;
    // padding: 30px;
    // box-sizing: border-box;
    border-radius: 14px;
    .cell-title {
      flex: 7;
    }
    .card-tit {
      font-size: 32px;
      font-weight: 700;
      color: #000;
      margin-bottom: 20px;
    }
    .gift-title {
      font-size: 30px;
      color: #1d252c;
    }
    .gift-content {
      font-size: 26px;
      color: #1d252c;
      margin-top: 10px;
    }
    .gift-price {
      font-size: 26px;
      font-weight: 700;
      color: #1d252c;
      margin-top: 10px;
    }
    .gift-block {
      border: 2px solid #f8f8f8;
      border-radius: 10px;
      background-color: #f8f8f8;
      margin-bottom: 20px;
    }
    .active-gift {
      border-color: #F54966;
    }
  }
}
</style>
